import React from 'react'
import isEqual from 'lodash/isEqual'
import { TextField, InputAdornment, Table, TableRow, TableCell, TableBody, TableHead } from '@mui/material'
import type { BuffetWeight, BuffetWeightWeekday } from '../../station/stationTypes'
import css from './buffetWeightsForm.css'
const buffetBeginTimes = [
  {
    startTime: '10:30:00',
    endTime: '12:00:00',
  },
  {
    startTime: '11:00:00',
    endTime: '12:00:00',
  },
]
const buffetEndTimes = [
  {
    startTime: '12:00:00',
    endTime: '13:00:00',
  },
  {
    startTime: '13:00:00',
    endTime: '14:00:00',
  },
  {
    startTime: '14:00:00',
    endTime: '15:00:00',
  },
  {
    startTime: '15:00:00',
    endTime: '16:00:00',
  },
  {
    startTime: '16:00:00',
    endTime: '17:00:00',
  },
  {
    startTime: '17:00:00',
    endTime: '18:00:00',
  },
  {
    startTime: '18:00:00',
    endTime: '19:00:00',
  },
  {
    startTime: '19:00:00',
    endTime: '20:00:00',
  },
  {
    startTime: '20:00:00',
    endTime: '21:00:00',
  },
  {
    startTime: '21:00:00',
    endTime: '22:00:00',
  },
]

const createBuffetWeightsData = (
  buffetBeginAt: string,
  buffetEndAt: string,
  data: Array<BuffetWeight>,
): Array<BuffetWeight> =>
  buffetEndTimes
    .reduce(
      (data, item) => [...data, item],
      buffetBeginTimes.filter((bt) => bt.startTime === buffetBeginAt),
    )
    .map((item) => ({
      ...item,
      isDisabled: item.startTime < buffetBeginAt || item.endTime > buffetEndAt,
      weight: Number(data.filter((i) => i.startTime === item.startTime).map((i) => i.weight)[0]) || 0,
    }))

const timeToHoursAndMinutes = (time: string) => time.split(':').slice(0, 2).join(':')

type BuffetWeightRowProps = {
  data: BuffetWeight
}

const BuffetWeightCell = ({ data }: BuffetWeightRowProps) => (
  <TableCell className={css.buffetRow}>
    <TextField
      className={css.textField}
      type='number'
      value={data.weight || ''}
      fullWidth
      disabled={true}
      inputProps={{
        min: 0,
        max: 100,
      }}
      InputProps={{
        endAdornment: <InputAdornment position='end'>%</InputAdornment>,
      }}
    />
  </TableCell>
)

type BuffetWeightsFormProps = {
  stationId: string
  buffetBeginAt: string
  buffetEndAt: string
  weekday: BuffetWeightWeekday
  data: BuffetWeight[]
}
type BuffetWeightsFormState = {
  buffetWeights: BuffetWeight[]
}

class BuffetWeightsForm extends React.PureComponent<BuffetWeightsFormProps, BuffetWeightsFormState> {
  state: BuffetWeightsFormState = {
    buffetWeights: [],
  }

  componentDidMount() {
    this.setStateFromProps(this.props)
  }

  componentDidUpdate(prevProps: BuffetWeightsFormProps) {
    if (prevProps !== this.props) {
      this.setStateFromProps(this.props)
    }
  }

  setStateFromProps = (props: BuffetWeightsFormProps) => {
    this.setState({
      buffetWeights: createBuffetWeightsData(props.buffetBeginAt, props.buffetEndAt, props.data),
    })
  }
  isValid = () =>
    !isEqual(
      createBuffetWeightsData(this.props.buffetBeginAt, this.props.buffetEndAt, this.props.data),
      this.state.buffetWeights,
    )

  render() {
    const { buffetWeights } = this.state
    return (
      <div className={css.component}>
        <Table>
          <TableHead>
            <TableRow>
              {buffetWeights.map((item) => (
                <TableCell className={css.buffetHeader} key={'header_' + item.startTime}>
                  {timeToHoursAndMinutes(item.startTime)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              {buffetWeights.map((item) => (
                <BuffetWeightCell data={item} key={'value_' + item.startTime} />
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </div>
    )
  }
}

export default BuffetWeightsForm
